<template>
  <section>
    <HomeHeader />
    <HomeBullets />
    <HomeEvents />
    <HomeTestimonies />
    <HomeAbout />
    <!-- <HomeBoards /> -->
    <HomeService />
    <!-- <HomeLogos /> -->
    <HomeSponsor />
    <HomeContact />
  </section>
</template>

<script>
import * as partials from './partials'

export default {
  name: 'Home',
  components: { ...partials },
  metaInfo() {
    return this.$t('home.meta')
  }
}
</script>
